import { redirectToLogin } from "./redirectToLogin";

export type UnauthorizedHandler = () => void;

const defaultHandler: UnauthorizedHandler = () => {
  redirectToLogin();
};

let currentHandler: UnauthorizedHandler = defaultHandler;

// Заменяет реакцию на 401. `shared` не знает о роутере и QueryClient, поэтому `app/`
// может поставить переход без перезагрузки: `queryClient.clear()` + `router.navigate(...)`.
// Возвращает функцию, которая вернёт обработчик по умолчанию (удобно в тестах).
export const setUnauthorizedHandler = (handler: UnauthorizedHandler): (() => void) => {
  currentHandler = handler;
  return () => {
    currentHandler = defaultHandler;
  };
};

export const handleUnauthorized = (): void => {
  currentHandler();
};
